(function () {
  'use strict';

  var STORAGE_KEY = 'tokha_favorites';

  function getFavorites() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setFavorites(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      /* localStorage unavailable (private browsing etc) — fail silently */
    }
  }

  function isFavorited(handle) {
    return getFavorites().indexOf(handle) !== -1;
  }

  function toggleFavorite(handle) {
    var favorites = getFavorites();
    var index = favorites.indexOf(handle);
    if (index === -1) {
      favorites.push(handle);
    } else {
      favorites.splice(index, 1);
    }
    setFavorites(favorites);
    syncToggleButtons();
    updateCountBubble();
    document.dispatchEvent(new CustomEvent('tokha:favorites-changed', { detail: { favorites: favorites } }));
    return favorites.indexOf(handle) !== -1;
  }

  function syncToggleButtons() {
    var favorites = getFavorites();
    document.querySelectorAll('[data-favorite-toggle]').forEach(function (button) {
      var handle = button.getAttribute('data-favorite-toggle');
      var active = favorites.indexOf(handle) !== -1;
      button.classList.toggle('is-favorited', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      var label = active ? 'Remove from favorites' : 'Add to favorites';
      button.setAttribute('aria-label', label);
      button.title = label;
    });
  }

  function updateCountBubble() {
    var count = getFavorites().length;
    var bubble = document.getElementById('favorites-count-bubble');
    if (!bubble) return;
    if (count > 0) {
      bubble.hidden = false;
      bubble.querySelector('span').textContent = count > 99 ? '99+' : String(count);
    } else {
      bubble.hidden = true;
    }
  }

  function renderFavoritesDrawer() {
    var list = document.getElementById('favorites-drawer-list');
    var empty = document.getElementById('favorites-drawer-empty');
    if (!list) return;
    var favorites = getFavorites();

    if (favorites.length === 0) {
      list.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;

    list.innerHTML = '<p class="favorites-drawer__loading">Loading your favorites…</p>';

    Promise.all(
      favorites.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (res) { return res.ok ? res.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      list.innerHTML = '';
      products.forEach(function (product) {
        if (!product) return;
        var img = product.featured_image ? product.featured_image : (product.images && product.images[0]);
        var price = (product.price / 100).toFixed(2);

        var item = document.createElement('div');
        item.className = 'favorites-drawer__item';

        var media = document.createElement('a');
        media.href = '/products/' + product.handle;
        media.className = 'favorites-drawer__item-media';
        if (img) {
          var imgEl = document.createElement('img');
          imgEl.src = img + '&width=160';
          imgEl.alt = product.title;
          imgEl.loading = 'lazy';
          imgEl.width = 80;
          imgEl.height = 80;
          media.appendChild(imgEl);
        }

        var info = document.createElement('div');
        info.className = 'favorites-drawer__item-info';
        var titleLink = document.createElement('a');
        titleLink.href = '/products/' + product.handle;
        titleLink.className = 'favorites-drawer__item-title';
        titleLink.textContent = product.title;
        var priceSpan = document.createElement('span');
        priceSpan.className = 'favorites-drawer__item-price';
        priceSpan.textContent = 'From $' + price;
        info.appendChild(titleLink);
        info.appendChild(priceSpan);

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'favorites-drawer__item-remove';
        removeBtn.setAttribute('data-favorite-toggle', product.handle);
        removeBtn.setAttribute('aria-label', 'Remove from favorites');
        removeBtn.title = 'Remove from favorites';
        removeBtn.innerHTML = '&times;';

        item.appendChild(media);
        item.appendChild(info);
        item.appendChild(removeBtn);
        list.appendChild(item);
      });
      syncToggleButtons();
      if (list.children.length === 0 && empty) {
        empty.hidden = false;
      }
    });
  }

  function openFavoritesDrawer() {
    var drawer = document.getElementById('favorites-drawer');
    if (!drawer) return;
    renderFavoritesDrawer();
    drawer.classList.add('is-open');
    document.body.classList.add('favorites-drawer-open');
  }

  function closeFavoritesDrawer() {
    var drawer = document.getElementById('favorites-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('favorites-drawer-open');
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-favorite-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      var handle = toggle.getAttribute('data-favorite-toggle');
      toggleFavorite(handle);
      if (document.getElementById('favorites-drawer') && document.getElementById('favorites-drawer').classList.contains('is-open')) {
        renderFavoritesDrawer();
        updateCountBubble();
      }
      return;
    }

    if (e.target.closest('[data-favorites-open]')) {
      e.preventDefault();
      openFavoritesDrawer();
      return;
    }

    if (e.target.closest('[data-favorites-close]') || e.target.id === 'favorites-drawer-overlay') {
      e.preventDefault();
      closeFavoritesDrawer();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeFavoritesDrawer();
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncToggleButtons();
    updateCountBubble();
  });

  if (document.readyState !== 'loading') {
    syncToggleButtons();
    updateCountBubble();
  }
})();
